import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401f022e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "container p-lg-5 p-3" }
const _hoisted_3 = { class: "text-center fw-bold mb-5" }
const _hoisted_4 = { class: "fs-6 fw-bold mb-4" }
const _hoisted_5 = { class: "fs-6 fw-bold" }
const _hoisted_6 = { class: "fs-6 fw-bold" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const transitToTop = () => {
  if (route.path.split('/')[1] === 'alumni') {
    router.push(`/alumni/login`)
  } else {
    router.push(`/community/users/login`)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(translate)('SU40leftYelloop')), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)('SU40content')), 1),
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(translate)('SU40content2')), 1),
      _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(translate)('SU40content3')), 1)
    ])
  ]))
}
}

})